import { apiRequest, createAPIModule } from '@/api/utils';

export default {
  ...createAPIModule({
    endpoint: 'zonas',
  }),

  createPostcode: ({ zoneId, data }) => apiRequest.post(`zonas/${zoneId}/codigospostales`, data),

  deletePostcode: ({ zoneId, postcodeId }) =>
    apiRequest.delete(`zonas/${zoneId}/codigospostales/${postcodeId}`),

  getPostcodes: id => apiRequest.get(`zonas/${id}/codigospostales`),

  preCreatePostcode: id => apiRequest.get(`zonas/${id}/codigospostales/create`),
};
